import { ProductTypeSchema } from '@reward-platform/ancillaries-schemas/common'
import { isClient } from '~/utils/envChecks'
import { useEffect } from 'react'
import { isOrdersPage } from '~/server/utils/middlewareUtils'
import { usePaymentOptionsContext } from '../PaymentOptionsContext/PaymentOptionsProvider'

/**
 * Ensures that the HOTEL balance booster is only active on the Orders page.
 * If the user navigates away, the booster is automatically removed.
 */
export const useEnsureHotelBoosterOnlyOnOrdersPage = () => {
  const { paymentOptions, removeBalanceBoosterForItem } = usePaymentOptionsContext()

  const isBoosterSelected = !!paymentOptions?.HOTEL?.balanceBooster

  useEffect(() => {
    if (isClient()) {
      const isOnOrdersPage = isOrdersPage(window.location.pathname)

      if (!isOnOrdersPage && isBoosterSelected) {
        removeBalanceBoosterForItem(ProductTypeSchema.enum.HOTEL)
      }
    }
  }, [isBoosterSelected, removeBalanceBoosterForItem])
}
